import {
  PATH_ADD_ADMIN,
  PATH_ADD_CLINIC,
  PATH_ADMINS,
  PATH_CDIC_CLIENT_INFO,
  PATH_CDIC_COUPON_LIST,
  PATH_CDIC_COUPON_REDEEM,
  PATH_CHANGE_PASSWORD,
  PATH_CLIENT_CREATE,
  PATH_CLIENT_INFO,
  PATH_CLINIC,
  PATH_COUPON_FAMILY,
  PATH_COUPON_LIST,
  PATH_COUPON_MANAGEMENT,
  PATH_COUPON_REDEEM,
  PATH_CREATE_COUPON_FAMILY,
  PATH_FORGOT_PASSWORD,
  PATH_GENERATE_CDIC_COUPON,
  PATH_GENERATE_COUPON,
  PATH_HOME,
  PATH_LOGIN,
  PATH_LOGIN_BY_PHONE,
  PATH_MY_PROFILE,
  PATH_OTP,
  PATH_PATIENT,
  PATH_PRIVACY_POLICY,
  PATH_REDEEM_CDIC_COUPON,
  PATH_REDEEM_COUPON,
  PATH_SIGNUP,
  PATH_TERMS_AND_CONDITIONS,
} from "./paths";

export const adminRoutes = [
  PATH_HOME,
  PATH_CLIENT_INFO,
  PATH_CLIENT_CREATE,
  PATH_COUPON_MANAGEMENT,
  PATH_COUPON_REDEEM,
  PATH_COUPON_LIST,
  PATH_COUPON_FAMILY,
  PATH_CREATE_COUPON_FAMILY,
  PATH_GENERATE_COUPON,
  PATH_CLINIC,
  PATH_ADD_CLINIC,
  PATH_ADMINS,
  PATH_ADD_ADMIN,
  PATH_CDIC_COUPON_REDEEM,
  PATH_CDIC_CLIENT_INFO,
  PATH_CDIC_COUPON_LIST,
  PATH_GENERATE_CDIC_COUPON,
] as string[];

export const clinicRoutes = [
  PATH_REDEEM_CDIC_COUPON,
  PATH_REDEEM_COUPON,
  PATH_PATIENT,
  PATH_TERMS_AND_CONDITIONS,
  PATH_PRIVACY_POLICY,
  PATH_MY_PROFILE,
  PATH_CHANGE_PASSWORD,
  PATH_FORGOT_PASSWORD,
  PATH_LOGIN,
  PATH_HOME,
] as string[];

export const authRoutes = [
  PATH_LOGIN,
  PATH_SIGNUP,
  PATH_CHANGE_PASSWORD,
  PATH_OTP,
  PATH_LOGIN_BY_PHONE,
] as string[];

export const publicRoutes: string[] = [];
